import { FC } from 'react';
import { Form as FormikForm } from 'formik';

import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Fab, { FabProps } from 'components/Fab';

type Props = {
  tooltip?: string;
} & FabProps;

const Form: FC<Props> = ({ children, tooltip, ...rest }) => (
  <FormikForm>
    <Box>{children}</Box>

    {tooltip ? (
      <Tooltip title={tooltip} placement="left">
        <Fab {...rest} />
      </Tooltip>
    ) : (
      <Fab {...rest} />
    )}
  </FormikForm>
);

export default Form;
